import React from "react";
import { InfoCard, InfoRow } from "@components/styles/dataDisplay";
import { CustomHeading, HeadingContainer, Subtitle, TitleContainer } from "@pages/style";
import Skeleton from "react-loading-skeleton";
import { CustomSkeleton } from "./style";

const LawsuitDataTabSkeleton: React.FC = () => {
  return (
    <div>
      <HeadingContainer>
        <TitleContainer>
          <CustomHeading noMargin size="sm">
            <Skeleton width={256} height={20} />
          </CustomHeading>
          <Subtitle color="gray" size="lg" noMargin>
            <Skeleton width={440} height={16} />
          </Subtitle>
        </TitleContainer>
      </HeadingContainer>

      <InfoCard spacing="lg" border>
        <div key="lawsuit-container">
          <InfoRow>
            <Skeleton width={216} height={16} />
            <CustomSkeleton marginBottom={false} height={16} />
          </InfoRow>

          <InfoRow>
            <Skeleton width={216} height={16} />
            <CustomSkeleton marginBottom={false} height={16} />
          </InfoRow>

          <InfoRow>
            <Skeleton width={216} height={16} />
            <CustomSkeleton marginBottom={false} height={16} />
          </InfoRow>
        </div>
      </InfoCard>
    </div>
  );
};

export default LawsuitDataTabSkeleton;
